import { render, staticRenderFns } from "./BtnUserAccount.vue?vue&type=template&id=e480654a&"
import script from "./BtnUserAccount.vue?vue&type=script&lang=ts&"
export * from "./BtnUserAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports